import { axiosFetch } from "../../utils/AxiosFetch";
import { addCommentsConstant } from "../constants";
import { SnackbarActions } from './snackbar.actions';

export const addNewComments = (req) => (dispatch) => {
    axiosFetch({
        method: "post",
        url: "/OKRs/okr/comment",
        requestConfig: req
    })

        .then((res) => {

            if (res.status === 200) {
                dispatch(addNewComments_Succeed(res));
            }
            else if (res.status === 400) {
                dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
            }
            else if (res.status === 401) {
                window.location.href = "/";
            }
        })

        .catch((err) => {
            dispatch(addNewComments_Failed(err))
        })


    function addNewComments_Succeed(data) {
        return {
            type: addCommentsConstant.ADD_NEW_COMMENTS_SUCCESS,
            payload: data
        }
    }

    function addNewComments_Failed(err) {
        return {
            type: addCommentsConstant.ADD_NEW_COMMENTS_FAILURE,
            payload: err
        }
    }
};
